/**
 * @flow
 * @format
 */

import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Card, Row, Col } from 'reactstrap';
import cc from 'classcat';

import { branch } from '~/utils';
import { getFieldValues, getFieldErrors } from '~/selectors/design';

import type { Connector } from 'react-redux';

// import classes from './FieldMessage.scss';
import wrapperClasses from '../FieldWrapper/FieldWrapper.scss';

type OwnPropsType = {
  id: string,
  style?: { [key: string]: string },
};

type ReduxPropsType = {
  currentValue: string,
  error: Array<string>,
};

type PropsType = OwnPropsType & ReduxPropsType;

export class FieldMessage extends React.Component<PropsType, *> {
  static defaultProps = {
    currentValue: '',
    style: {},
    error: [],
  };

  shouldComponentUpdate(nextProps: PropsType) {
    return !_.isEqual(
      [this.props.error, this.props.currentValue],
      [nextProps.error, nextProps.currentValue],
    );
  }

  render() {
    const hasError = this.props.error.length > 0;
    const content = (
      <Card
        className={cc({
          [wrapperClasses.card]: true,
          [wrapperClasses.error]: hasError,
          [wrapperClasses.warning]: typeof this.props.currentValue === 'string',
        })}
        style={this.props.style}
      >
        <Row>
          <Col>
            {branch(hasError, this.props.error, this.props.currentValue)}
          </Col>
        </Row>
      </Card>
    );

    const message = this.props.currentValue || '';

    return branch(hasError || message.length > 0, content);
  }
}

function mapStateToProps(
  state: AppStateType,
  ownProps: OwnPropsType,
): PropsType {
  const values = getFieldValues(state);
  const fieldErrors = getFieldErrors(state);

  const data = values[ownProps.id];
  const error: string[] = fieldErrors[ownProps.id];

  return {
    ...ownProps,
    currentValue: _.get(data, ['currentValue']),
    error,
  };
}

const connector: Connector<OwnPropsType, PropsType> = connect(mapStateToProps);

export default connector(FieldMessage);



// WEBPACK FOOTER //
// ./src/components/FieldMessage/FieldMessage.js